import { getLocalTimeZone } from '@internationalized/date';
import { useMemo } from 'react';
import { useGlobal, useWeeklySqlViewFilters } from '@/store';
import { WeeklySqlViewFiltersSection } from './components/filters-section';
import { WeeklyRecordReviewsTable } from './components/weekly-record-reviews-table';

export const WeeklySqlViewPage = () => {
  const search = useWeeklySqlViewFilters.use.search();
  const createdAt = useWeeklySqlViewFilters.use.createdAt();
  const createdBy = useWeeklySqlViewFilters.use.createdBy();
  const recordIds = useWeeklySqlViewFilters.use.recordIds();
  const type = useWeeklySqlViewFilters.use.type();
  const state = useWeeklySqlViewFilters.use.state();
  const dbType = useGlobal.use.dbType();
  const actionedBy = useWeeklySqlViewFilters.use.actionedBy();

  const createdAtIso = useMemo(() => {
    if (!createdAt) return undefined;
    const date = createdAt.toDate ? createdAt.toDate(getLocalTimeZone()) : new Date(createdAt.toString());
    return date.toISOString();
  }, [createdAt]);

  const filterKey = useMemo(
    () => JSON.stringify({ search, createdAtIso, createdBy, recordIds, type, state, dbType }),
    [search, createdAtIso, createdBy, recordIds, type, state, dbType],
  );

  return (
    <div className='flex flex-col h-full gap-4'>
      <WeeklySqlViewFiltersSection />
      <div className='overflow-x-auto w-full'>
        <WeeklyRecordReviewsTable
          filterKey={filterKey}
          search={search}
          createdAtIso={createdAtIso}
          createdBy={createdBy}
          recordIds={recordIds}
          type={type}
          state={state}
          actionedBy={actionedBy}
          title='Weekly SQL View'
        />
      </div>
    </div>
  );
};
